var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccount(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "My_Order",
    "data-name": "My Order",
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.25,
    height: 30,
    viewBox: "0 0 26.25 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_38231",
    "data-name": "Path 38231",
    d: "M24.375,8.371a.943.943,0,0,0-.937-.871H18.75V5.625a5.625,5.625,0,0,0-11.25,0V7.5H2.813a.943.943,0,0,0-.937.871L0,28.929a1.007,1.007,0,0,0,.268.737A.824.824,0,0,0,.938,30H25.313a.93.93,0,0,0,.67-.335,1.007,1.007,0,0,0,.268-.737Zm-15-2.746a3.75,3.75,0,0,1,7.5,0V7.5h-7.5Zm-7.433,22.5L3.683,9.375H7.5v2.143a1.946,1.946,0,0,0-.937,1.607A1.872,1.872,0,0,0,8.438,15a1.916,1.916,0,0,0,1.875-1.875,1.946,1.946,0,0,0-.937-1.607V9.375h7.5v2.143a1.946,1.946,0,0,0-.938,1.607A1.872,1.872,0,0,0,17.813,15a1.916,1.916,0,0,0,1.875-1.875,1.946,1.946,0,0,0-.937-1.607V9.375h3.817l1.674,18.75Zm7.3-7.031a.83.83,0,1,1,1.205-1.138l1.473,1.473L15.8,17.478a.852.852,0,1,1,1.205,1.205l-4.487,4.554-.067.067a.852.852,0,0,1-1.205-.067Z",
    fill: "#fff",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccount);
export default __webpack_public_path__ + "static/media/account.1e497a88a8b4c061db58c820461c8cee.svg";
export { ForwardRef as ReactComponent };